import Header from "../components/header.jsx";
import Sidebar from "../components/sidebar.jsx";
import StaffDetails from "../components/staffDetails.jsx";
import Footer from "../components/footer.jsx";

function StaffDetailspage() {
    return (
        <div>
        <div className='wrapper'>
          <Header />
          <Sidebar /> 
          <StaffDetails/> 
        </div>
        <Footer /> 
      </div>
      // <Login/>
      );
}
export default StaffDetailspage;
